import React from 'react';
import Helmet from 'react-helmet';

import Grid from './grid';
import Tile from './tile';
import Heading from './heading';

export default ({ category, title }) => (
    <div css={{ flex: 1 }}>
        <Helmet title={title} meta={[{ property: 'og:title', content: title }]} />
        <Heading>{title}</Heading>
        <Grid numTiles={4}>
            <Tile href={`/calculators/${category}`} title="Calculator" image="calculator" />
            <Tile href={`/articles/${category}`} title="Articles" image="article" />
            <Tile href={`/wyse-awards/${category}`} title="Wyse Awards" image="awards" />
            <Tile href="/terms-and-knowledge" title="Terms & Knowledge" image="terms" />
        </Grid>
    </div>
);
